module.exports = __webpack_public_path__ + "media/NSM-Desktop-Video.4b676ccb.mp4";